// Role Lists library (Step 4) — loaded once from GET /api/dev/role-lists (backed by backend/data/development_inventory_role_lists.csv).
import { useEffect, useState } from "react";
import axios from "axios";

let ITEMS = [];
let META = { version: "" };
let loader = null;
export const ROLE_ITEM_BY_ID = {};

export function loadRoleLists() {
  if (!loader) {
    loader = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dev/role-lists`).then(r => {
      ITEMS = r.data.items || []; META = { version: r.data.version || "" };
      Object.keys(ROLE_ITEM_BY_ID).forEach(k => delete ROLE_ITEM_BY_ID[k]);
      ITEMS.forEach(i => { ROLE_ITEM_BY_ID[i.id] = i; });
      return ITEMS;
    }).catch(e => { loader = null; throw e; });
  }
  return loader;
}

export function useRoleLists() {
  const [state, setState] = useState({ ready: ITEMS.length > 0, meta: META, error: null });
  useEffect(() => {
    let live = true;
    loadRoleLists().then(() => live && setState({ ready: true, meta: META, error: null }))
      .catch(() => live && setState({ ready: false, meta: META, error: "Could not load the role lists" }));
    return () => { live = false; };
  }, []);
  return state;
}

// Active items for a list (file order), plus any retired item already chosen so old entries stay readable.
export const listItems = (list, chosen = []) => ITEMS.filter(i => i.list === list && (i.status === "active" || chosen.includes(i.id)));
export const listCategories = (list, chosen) => [...new Set(listItems(list, chosen).map(i => i.category || ""))];
export const roleName = (id) => (id ? ROLE_ITEM_BY_ID[id]?.name || id : "");
export const roleItem = (id) => (id ? ROLE_ITEM_BY_ID[id] : null);
export const LIMITS = { responsibilityIds: 3, playTypeIds: 3 }; // matchupIds: pick all that apply
export const roleLabel = (id) => { const i = roleItem(id); return !i ? id : i.status === "active" ? i.name : `${i.name} (retired)`; };
